export const Content = require('./Content.png')
export const Chart = require('./Chart.png')
export const SocialFeed = require('./SocialFeed.png')
export const Record = require('./Record.png')
export const RecordList = require('./RecordList.png')
export const Automation = require('./Automation.png')
export const Calendar = require('./Calendar.png')
export const File = require('./File.png')
export const RecordOrganizer = require('./RecordOrganizer.png')
export const RecordRevisions = require('./RecordRevisions.png')
export const IFrame = require('./IFrame.png')
export const Metric = require('./Metric.png')
export const Comment = require('./Comment.png')
export const Report = require('./Report.png')
export const Progress = require('./Progress.png')
